// Shared admin auth surface constants.
//
// SUPPORT_EMAIL is the single source of truth for the address shown to admins
// on /access-help, lockout toasts, and admin-only recovery mockups. Pool §11
// (auth-onboarding spec) plus 0.D.1 AuthService keep TOTP on the admin pool,
// so admins who lose both their authenticator and their backup codes can't
// self-recover; they email this address and ops verifies identity out of
// band. SPARK-525 lifted this out of inline `support@spark.local` strings.
//
// NOTE: This is the admin-auth-surface fallback only (upstream of org
// resolution). The codebase has three distinct support-email values today:
//
//   1. SUPPORT_EMAIL (this file)                       admin auth surfaces
//   2. org_settings.support_email via BrandCascadeResolver
//                                                       per-org, learner-side
//   3. DEFAULT_SUPPORT_EMAIL in
//      apps/api/src/notifications/email/renderer/render-context.ts
//                                                       outbound emails
//
// Keep these in sync when the prod address changes; there is no automated
// cross-check today.
export const SUPPORT_EMAIL = 'support@sparkcourses.org';
